import { useQuery } from '@tanstack/react-query';

import { GroupService } from './groupService';
import { GroupKey } from './keys';

export function useGetGroupUsers(id?: number, enabled = true) {
  return useQuery({
    queryKey: [GroupKey.GROUP_USERS, id],
    queryFn: () => GroupService.getGroupUsers(id).then((response) => response.data),
    enabled: enabled && !!id,
  });
}
